import React from 'react';
import ListIcon from 'assets/svg/view-switcher-list.svg';
import CardIcon from 'assets/svg/view-switcher-card.svg';
import { SearchViewMode } from 'components/list-view-switcher/constants';
import { withSearchViewSwitcherEvents } from 'components/list-view-switcher/basic-switch';
import { PillSwitcherWrapper, PillSwitcherItem } from 'components/list-view-switcher/styled';
import { SearchViewSwitcherProps } from 'components/list-view-switcher';
import { useLocale } from 'locale';

const PillViewSwitcherBase: React.FC<SearchViewSwitcherProps> = ({ mode, setMode, onClick }) => {
  const { t } = useLocale();
  const isGrid = mode === SearchViewMode.Grid;
  const onToggleClick = (view: SearchViewMode) => {
    onClick(view);
    setMode(view);
  };

  const setGridMode = () => onToggleClick(SearchViewMode.Grid);
  const setListMode = () => onToggleClick(SearchViewMode.List);

  // card first: under the app's RTL direction it lands on the right, as in the Figma
  return (
    <PillSwitcherWrapper data-auto="search_results_view_switcher">
      <PillSwitcherItem
        type="button"
        isActive={isGrid}
        aria-pressed={isGrid}
        onClick={setGridMode}
        aria-label={t('searchListView.viewSwitcher.card')}
        data-auto="search_results_view_switcher_card_button"
      >
        <CardIcon />
      </PillSwitcherItem>
      <PillSwitcherItem
        type="button"
        isActive={!isGrid}
        aria-pressed={!isGrid}
        onClick={setListMode}
        aria-label={t('searchListView.viewSwitcher.list')}
        data-auto="search_results_view_switcher_list_button"
      >
        <ListIcon />
      </PillSwitcherItem>
    </PillSwitcherWrapper>
  );
};

export const PillViewSwitcher = withSearchViewSwitcherEvents(PillViewSwitcherBase);
